import { useStore } from '@/store/useStore';
import { DealEditor } from './DealEditor';
import { BranchEditor } from './BranchEditor';
import { EmployeeEditor } from './EmployeeEditor';
import { TeamEditor } from './TeamEditor';
import { ConfirmDialog } from './ConfirmDialog';
import { HelpModal } from './HelpModal';

export function ModalsRoot() {
  const modal = useStore((s) => s.modal);
  const setModal = useStore((s) => s.setModal);
  if (!modal) return null;
  const close = () => setModal(null);
  switch (modal.kind) {
    case 'deal': return <DealEditor id={modal.id} preset={modal.preset} onClose={close} />;
    case 'branch': return <BranchEditor id={modal.id} onClose={close} />;
    case 'employee': return <EmployeeEditor id={modal.id} onClose={close} />;
    case 'team': return <TeamEditor id={modal.id} onClose={close} />;
    case 'help': return <HelpModal onClose={close} />;
    case 'confirm': return (
      <ConfirmDialog
        title={modal.title}
        message={modal.message}
        onConfirm={() => { modal.onConfirm(); close(); }}
        onClose={close}
        danger={modal.danger}
      />
    );
  }
}
